










































































import {Component, Prop, Vue} from 'vue-property-decorator';
import {
	BranchLocationOption,
	CreateServiceRecordPayload,
	LocationOption, ProjectLocationOption,
	ServiceDTO,
	ServiceFilter
} from "@/components/payroll/business/services/ServiceDTO";
import PortalInput from "@/components/common/PortalInput.vue";
import {IEmployment} from "@/dto/payroll/IEmployment";
import EmploymentService from "@/services/EmploymentService";
import {ifValid, processError} from "@/utils/ComponentUtils";
import SelectOption, {OptionsBuilder} from "@/components/common/SelectOption";
import PortalSelect from "@/components/common/PortalSelect.vue";
import {EmploymentFilter} from "@/dto/payroll/Filters";
import {EmploymentStatus} from "@/components/payroll/business/employments/contractors/Contractor";
import ServiceOrchestrator from "@/services/ServiceOrchestrator";
import Application from "@/state/Application";
import CompanyService from "@/services/CompanyService";
import PortalTextarea from "@/components/common/PortalTextarea.vue";
import {LocaleOptions} from "luxon";
import PortalDateTime from "@/components/common/PortalDateTime.vue";
import PortalDate from "@/components/common/PortalDate.vue";
import ServiceRecordOrchestrator from "@/services/ServiceLogOrchestrator";

@Component({
	components: {PortalDate, PortalDateTime, PortalTextarea, PortalSelect, PortalInput}
})
export default class CustomerServiceLogCreationModal extends Vue {

	private selectedLocation: LocationOption | null = null;
	private selectedService: ServiceDTO | null = null;
	private locationOptions: Array<SelectOption> = [];
	private selectedCustomer: IEmployment | null = null
	private customers: Array<IEmployment> = []
	private services: Array<ServiceDTO> = [];
	private req = new CreateServiceRecordPayload()

	@Prop()
	private callback!: () => void

	selected() {
		this.selectedLocation!.selected(this.req)
	}

	selectService() {
		this.req.serviceId = this.selectedService!.id
	}

	get customerOptions(): Array<SelectOption> {
		return this.customers.map(c => SelectOption.builder().title(c.employer.name).value(c).build())
	}

	get serviceOptions(): Array<SelectOption> {
		return this.services.map(s => SelectOption.builder().title(s.name + ' ' + s.formattedPrice).value(s).build())
	}

	get rxLocationOptions(): Array<SelectOption> {
		return this.locationOptions
	}

	private loadEmployments() {
		if (this.customers.length > 0) return Promise.resolve()
		return EmploymentService.getAllByFilter(
			new EmploymentFilter(
				{
					types: ["FOREIGN", "CONTRACTOR"],
					status: [EmploymentStatus.NEW, EmploymentStatus.ACTIVE, EmploymentStatus.PENDING_FOR_DOCUMENTS],
					detailsId: this.$wss.getCurrent.id,
				}
			)
		).then(
			res => {
				if (res.data.length > 0) {
					this.req.assigneeId = res.data[0].id;
				}
				this.customers = res.data;
			},
			err => processError(err, this)
		)
	}

	private async loadServices(): Promise<void> {
		if (!this.selectedCustomer) return;
		return ServiceOrchestrator.getAllByFilter(
			new ServiceFilter(
				{
					companyId: this.selectedCustomer!.employer.id,
					active: true
				}
			)
		).then(
			res => {
				this.services = res.data;
			},
			err => processError(err, this)
		)
	}

	private loadLocations() {
		if (!this.selectedCustomer) return;
		return Promise.all(
			[
				CompanyService.getProjectsByCompanyId(this.selectedCustomer!.employer.id).then(
					res => {
						if (res.data.length > 0) {
							this.locationOptions.push(...res.data.filter(it => it.address).map(it =>
								SelectOption.builder()
									.title(it.title!)
									.value(ProjectLocationOption.of(it.id!))
									.build())
							)
						}
					}
				),
				CompanyService.getBranches(this.selectedCustomer!.employer.id).then(
					res => {
						if (res.data.length > 0) {
							this.locationOptions.push(...res.data.filter(it => it.address).map(it =>
								SelectOption.builder()
									.title(it.title!)
									.value(BranchLocationOption.of(it.id!))
									.build())
							)
						}
					}
				),
				CompanyService.getHeadQuarter(this.selectedCustomer!.employer.id).then(
					res => {
						if (res.data) {
							this.locationOptions.push(
								SelectOption.builder()
									.title(res.data.title!)
									.value(BranchLocationOption.of(res.data.id!))
									.build()
							)
						}
					}
				)
			]
		).then(
			() => {return;},
			err => processError(err, this)
		)
	}

	private loadData() {
		Application.startLoading();
		this.loadEmployments()
			.then(() => this.loadServices())
			.then(() => this.loadLocations())
			.finally(() => Application.stopLoading())
	}

	mounted() {
		this.loadData()
	}

	save() {
		ifValid(this, () => {
			Application.startLoading()
			ServiceRecordOrchestrator.createLog(this.req).then(
				() => {
					this.$modal.hideAll()
					Application.stopLoading()
					this.callback()
				},
				err => processError(err, this)
			)
		})
	}

}
